import { validateQueryParams } from '../../utils/api/api-utils';
import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { FILTER_ENDPOINT, MODELO_NUMERARIO_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    MODELO_NUMERARIO_ENDPOINT
  ]);
}
export async function fetchByFilter(params = []) {
  const validatedParams = validateQueryParams(params);
  if (validatedParams.length) {
    return doGetQCXRequest([
      MODELO_NUMERARIO_ENDPOINT, FILTER_ENDPOINT
    ], validatedParams);
  }
  return { data: [] };
}

export async function fetchById(id) {
  return doGetQCXRequest([
    MODELO_NUMERARIO_ENDPOINT,
    id
  ]);
}

export async function register(data) {
  return doPostQCXRequest(
    [MODELO_NUMERARIO_ENDPOINT],
    data
  );
}

export async function save(data) {
  return doPutQCXRequest(
    [MODELO_NUMERARIO_ENDPOINT],
    data
  );
}

export async function activateById(id) {
  return doPutQCXActivateRequest(
    [MODELO_NUMERARIO_ENDPOINT],
    id
  );
}

export async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [MODELO_NUMERARIO_ENDPOINT],
    id
  );
}
